import moment from 'moment';

// maps date string values to moments
function stringToMoment<T> (value: T, key?: string): T | moment.Moment {
  // no key, just convert to Moment
  if (typeof key === 'undefined') {
    if (value != null && typeof value === 'string') {
      return moment(value);
    } else {
      return value;
    }
  }

  switch (key) {
    case 'creationDate':
    case 'modificationDate':
    case 'dueDate':
    case 'actorDate':
    case 'reminderDate':
    case 'finishedDate':
    case 'autoReleaseDate':
    case 'installedDate':
    case 'kitDate':
    case 'kitInstalledDate':
    case 'startedDate':
    case 'inactivatedDate':
      return (typeof value === 'string') ? moment(value) : value;
    default:
      return value;
  }
}

function itemToString<T> (value: T): T | string {
  if (moment.isMoment(value)) {
    return momentToString(value);
  } else {
    return value;
  }
}

function momentToString (value: moment.Moment): string {
  return value.format('YYYY-MM-DDTHH:mm:ss.SSSZ');
}

function itemToMoment<T> (value: T, key: string): T | moment.Moment {
  return stringToMoment(value, key);
}

export {
  itemToMoment
}

const MomentSupport = {
  itemToString,
  stringToMoment,
  momentToString,
  itemToMoment
};

export default MomentSupport;
